import i18n from '../locales/index'
import axios from 'axios'
import { Message, Spin } from 'view-design'
import Cookies from 'js-cookie'
// import config from '@/config'
import { TOKEN_KEY, setToken } from '@/libs/util'
import router from '@/router'

// const baseUrl = process.env.NODE_ENV === 'development' ? config.baseUrl.dev : config.baseUrl.pro
axios.defaults.baseURL = process.env.VUE_APP_API_HOST

axios.interceptors.request.use(
  function (config) {
    // console.info('config', config)
    const token = Cookies.get(TOKEN_KEY)
    if (token) {
      const shopId = localStorage.getItem('SHOPID');
      config.headers.Authorization = token
      config.headers.ShopId = parseInt(shopId) || '';
    }
    if (config.base) {
      switch (config.base) {
        case 'CONFIG': config.baseURL = process.env.VUE_APP_CONFIG_API_HOST; break;
        case '/': config.baseURL = process.env.VUE_APP_ROOT_API_HOST; break;
      }
    }

    return config
  },
  function (error) {
    return Promise.reject(error)
  }
)

axios.interceptors.response.use(
  (response) => {
    return response.data
  },
  (error) => {
    if (error.response) {
      if (/^401$/.test(error.response.status)) {
        Message.error(error.response.data.message)
        setToken('')
        router.replace('/login')
      } else if (/^4.*/.test(error.response.status)) {
        Spin.hide()
        Message.error({ content: error.response.data.message, duration: 3 })
      } else {
        Message.error(error.response.data.message)
      }
    }
    return Promise.reject(error.response)
  }
)
